import axios from "axios";
import {getAuthHeader,getUploadFileHeader,setStorage,removeStorage} from '../config/Utils';



export const getProfileDetail=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/profile-details`
    return axios.get(url,getAuthHeader()).then((res)=>{
        if (res.data.status) {
            removeStorage('userDetail')
            setStorage("userDetail", res.data.data);
        }
        return res.data
    })  
}

export const getProfileList=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/profile-list`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const addProfile=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/add-profile`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getDocumentTypes=()=>{
    const url=`${process.env.REACT_APP_API_URL}/document-types`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}


export const uploadDocument=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/add-admit-card`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
        
    })
}

export const deleteUploadedFile =async(body)=>{
  const {id,student_id,document_id}=body
    const url=`${process.env.REACT_APP_API_URL}/delete-document?id=${id}&&docId=${document_id}&&userId=${student_id}`
    return axios.delete(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getSelectedDetail=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/detail?id=${id}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const updatePersonalDetail=async(model)=>{
    const url=`${process.env.REACT_APP_API_URL}/personal-detail`
    return axios.put(url,model,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const updateProfileDetail=async(model)=>{
    const url=`${process.env.REACT_APP_API_URL}/update-profile-detail`
    return axios.put(url,model,getAuthHeader()).then((res)=>{
        return res.data
    })  
}



export const updateCourseDetail=async(model)=>{
    const url=`${process.env.REACT_APP_API_URL}/course-detail`
    return axios.put(url,model,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const uploadProfile= async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/upload-picture`
    return axios.post(url,body,getUploadFileHeader()).then((res)=>{
        return res.data;
    })
}

export const uploadDirectBankDetail=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/add-fee-detail`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
        
    })
}

export const getStudentFee=(id,ft)=>{
    const url=`${process.env.REACT_APP_API_URL}/student-fee?id=${id}&&ft=${ft}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const uploadPaymentStatus=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/save-payment-detail`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
        
    })
}

export const getStudentTransactions=async(userId)=>{
    const url=`${process.env.REACT_APP_API_URL}/user-transactions?id=${userId}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    }) 
}

export const getPaypalClientId=()=>{
    const url=`${process.env.REACT_APP_API_URL}/payment-api-credential`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const uploadStudyMaterialDetail=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/study-material-address`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getStudyMaterialDetail=async(userId)=>{
    const url=`${process.env.REACT_APP_API_URL}/get-study-material-address?id=${userId}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getStudyMaterialCountries=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/study-material-countries`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const enrollStudent=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/enroll-student`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getStudentEnrollmentDetail=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/enrollment-detail?id=${id}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const isProfileComplete=async(modal)=>{
    const url=`${process.env.REACT_APP_API_URL}/update-profile-complete-detail`
    return axios.post(url,modal,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const isProfileConfirmed=async(modal)=>{
    const url=`${process.env.REACT_APP_API_URL}/update-profile-picture-confirmed`
    return axios.post(url,modal,getAuthHeader()).then((res)=>{
        return res.data
    })  
}


export const getOfflinePaymentTypes=async()=>{
    const url=`${process.env.REACT_APP_API_URL}/offline-transaction-types`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const payOfflineFee=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/offline-fee-payment`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
        
    })
}
// const url=`http://172.25.19.51/registration_admin_23_24/api/txCashPrizeStore`
export const cashWinnerBankDetail=async(body)=>{
    const url=`https://admin.allenoverseas.com/2023-2024/api/txCashPrizeStore`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}


export const getCashWinnerBankDetailStatus=async(fno)=>{
    const url=`https://admin.allenoverseas.com/2023-2024/api/txCashPrizecheck?fno=${fno}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
        
    })
}

// const url=`https://admin.allenoverseas.com/staging/api/generateEnquiry?fno=${encdo_fno}&channel_name=${utmData.channel_name !==undefined ? utmData.channel_name :''}&current_channel_name=${utmData.current_channel_name !==undefined ? utmData.current_channel_name:''}&source=${utmData.source !==undefined?utmData.source:''}&lead_source=${utmData.lead_source !==undefined?utmData.lead_source:''}&campaign_name=${utmData.campaign_name !==undefined?utmData.campaign_name:''}&utm_adgroup=${utmData.utm_adgroup !==undefined?utmData.utm_adgroup:''}&utm_campaign=${utmData.utm_campaign !==undefined?utmData.utm_campaign:''}&utm_medium=${utmData.utm_medium !==undefined?utmData.utm_medium:''}&utm_source=${utmData.utm_source !==undefined?utmData.utm_source:''}&utm_term=${utmData.utm_term !==undefined?utmData.utm_term:''}`
export const salesforceSendFormNumber=async(utmData)=>{
    let encdo_fno = encodeURIComponent(window.btoa(utmData.form_num !==undefined ? utmData.form_num : utmData));
    const url=`https://admin.allenoverseas.com/2023-2024/api/generateEnquiry?fno=${encdo_fno}&channel_name=${utmData.channel_name !==undefined ? utmData.channel_name :''}&current_channel_name=${'NCC_CCP_Registration_2023-24'}&source=${utmData.source !==undefined?utmData.source:''}&lead_source=${utmData.lead_source !==undefined?utmData.lead_source:''}&campaign_name=${utmData.campaign_name !==undefined?utmData.campaign_name:''}&utm_adgroup=${utmData.utm_adgroup !==undefined?utmData.utm_adgroup:''}&utm_campaign=${utmData.utm_campaign !==undefined?utmData.utm_campaign:''}&utm_medium=${utmData.utm_medium !==undefined?utmData.utm_medium:''}&utm_source=${utmData.utm_source !==undefined?utmData.utm_source:''}&utm_term=${utmData.utm_term !==undefined?utmData.utm_term:''}&status=${utmData.status !==undefined?utmData.status:''}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getStudentExamResultDetail=async(fno)=>{
    const url=`${process.env.REACT_APP_API_URL}/get-tallentx-result?fNo=${fno}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}


export const getStudentResultNumber = async(form_number) => {
    // const url =  `https://172.25.19.23/tallentex/api/v2/student/result/${form_number}`
    // return axios.get(url,getAuthHeader()).then((res)=>{
    //     return res.data

    // }) 
}




export const referFriend=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/referral/register`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        if (res.data.status) {
            removeStorage('userDetail')
            setStorage("userDetail", res.data.data);
            setStorage("token", res.data.data.token);
        }
        return res.data
    })  
}

export const getReferralDetail=async(id)=>{
    const url=`${process.env.REACT_APP_API_URL}/referral/detail?id=${id}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })  
}
export const validateStudent = async(slug) => {
    const url =  `${process.env.REACT_APP_API_URL}/student/validation?s=${slug}`
    return axios.get(url).then((res)=>{
        return res.data
    }) 
}


// export const getPaymentGateways=async(body)=>{
//     const url=`http://172.25.19.51/ccp-2023-2024/api/payment-gateway`
//     return axios.post(url,body,getAuthHeader()).then((res)=>{
//         return res.data
//     })
// }



